// Listing Detail
export const LISTING_OFFER_SUBMIT_SUCCESS = 'listing-offer-submit-success'
